import { ProductTechnologyType } from "./productTechnology";

export type ErrorSource = keyof typeof ERROR_SOURCE_REGEX;

const ERROR_SOURCES_MAPPING: Record<ProductTechnologyType | "UNDEFINED", ErrorSource[]> = {
    UNDEFINED: ["MMC"],
    ELECTRONICS: [
        "TruControl",
        "TruConvert",
        "TruPlasma VHF",
        "TPR1000_G2_TPR3000_G2",
        "TPM7000_G2_THM7000_G2",
        "TPR3000",
        "THM7000_G3"
    ],
    LASER: ["MMC", "TruControl"],
    PUNCHING: ["MMC"],
    COMBINED: ["MMC", "TruControl"],
    BENDING: ["MMC"],
    SOFTWARE: [],
    CO2LASER: ["TruControl"],
    SOLIDSTATELASER: ["TruControl"],
    MARKINGLASER: ["TruControl"],
    AQUACUT: ["MMC"],
    TRUSHEAR: ["MMC"],
    AUTOMATION: ["MMC"],
    "2DLASERCUTTING": ["MMC", "TruControl"],
    "3DLASERCUTTING": ["MMC", "TruControl"],
    "3DPRINTING": ["AM_HMI", "AM_DESKTOP", "AM_TITP"],
    COOLER: ["MMC"],
    DIODELASER: ["TruControl"],
    DISKLASER: ["TruControl"],
    FIBERLASER: ["TruControl"],
    PULSEDLASER: ["TruControl"],
    WELDING: ["MMC", "TruControl"],
    SHORTPULSEDLASER: ["TruControl"],
    STORAGESYSTEM: ["MMC"],
    LASERTUBECUTTING: ["MMC", "TruControl"]
};
const FALLBACK_ERROR_SOURCES: ErrorSource[] = ["MMC"];

export const getErrorSourcesForTechnology = (productTechnology?: ProductTechnologyType | null): ErrorSource[] => {
    if (!productTechnology) {
        return FALLBACK_ERROR_SOURCES;
    }
    return ERROR_SOURCES_MAPPING[productTechnology] || FALLBACK_ERROR_SOURCES;
};

export const getErrorNumberRegexForTechnology = (technology?: ProductTechnologyType | null): string => {
    const errorSources = getErrorSourcesForTechnology(technology);
    return errorSources.map((source) => `(${ERROR_SOURCE_REGEX[source]})`).join("|");
};

const ERROR_SOURCE_REGEX = {
    MMC: "^([0-9]+)([\\.][0-9]+)*$",
    TruControl: "^[a-fA-F0-9]{4}( |\\.)?[a-fA-F0-9]{4}$",
    AM_HMI: "^[0-9]*$",
    AM_DESKTOP: "^[0-9]*$",
    AM_TITP: "^[A-Z]{3,4}(-)[0-9]{5}$",
    TruConvert: "^[0-9]{5}$",
    "TruPlasma VHF": "/^[0-9]{5}$",
    TPR1000_G2_TPR3000_G2: "^[0-9]{5}$",
    TPM7000_G2_THM7000_G2: "^[0-9]{5}$",
    TPR3000: "^[0-9]{5}$",
    THM7000_G3: "^[0-9]{5}$"
};

const UNKNOWN = "UNDEFINED";

export const getErrorSourceForErrorNumber = (errorNumber: string, technology: ProductTechnologyType): string => {
    const filteredErrorSources = getErrorSourcesForTechnology(technology).filter((errorSource) => {
        if (new RegExp(ERROR_SOURCE_REGEX[errorSource]).test(errorNumber)) {
            return errorSource;
        }
        return false;
    });
    if (filteredErrorSources.length === 0) {
        return UNKNOWN;
    }
    return filteredErrorSources[0];
};
